import { render } from "./ModeLightSPA.vue?vue&type=template&id=12408c48"
import script from "./ModeLightSPA.vue?vue&type=script&lang=js"
export * from "./ModeLightSPA.vue?vue&type=script&lang=js"

import "./ModeLightSPA.vue?vue&type=style&index=0&id=12408c48&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__